module.exports = __webpack_public_path__ + "static/media/logo-white.6d29a9e1.svg";